module.exports={
  "name": "plansheet",
  "version": "1.0.1",
  "private": true,
  "description": "Plansheet - multi-tenant, documentation-and-articulation-first SDLC management platform: Visions, Modules, Features, Work Items, a Kanban board, Claude session linking, and a foundational documentation library.",
  "main": "source/Pict-Application-Plansheet.js",
  "bin": {
    "plansheet-server": "source/cli/Plansheet-Server-Run.js"
  },
  "scripts": {
    "brand": "node node_modules/pict-section-theme/bin/pict-section-theme-brand.js --favicons html/favicons",
    "build:codemirror": "node build/build-codemirror-bundle.js",
    "build:codejar": "node build/build-codejar-bundle.js",
    "stamp:version": "node build/stamp-version.js",
    "//prebuild": "npm run brand is intentionally NOT in this chain: the brand mark (retold.brand Icon/Favicon) is the hand-drawn corner-cell-P title block, and the generator would overwrite it. Run `npm run brand` only if you mean to regenerate a geometric logo.",
    "prebuild": "npm run build:codemirror && npm run build:codejar && npm run stamp:version",
    "build": "npx quack build && npx quack copy && node bin/stamp-bundles.js",
    "start": "npx http-server dist -p 8189 -c-1 --silent",
    "start-server": "node source/cli/Plansheet-Server-Run.js",
    "deploy": "node ../plansheet-deploy-tool/bin/pdt.js deploy",
    "deploy:mcp": "node ../plansheet-deploy-tool/bin/pdt.js deploy-mcp",
    "deploy:site": "node ../plansheet-deploy-tool/bin/pdt.js deploy:site",
    "pdt": "node ../plansheet-deploy-tool/bin/pdt.js",
    "dev": "bash dev/dev.sh",
    "dev:clean": "bash dev/clean.sh",
    "dev:seed": "node dev/seed.js",
    "docs:gc": "node dev/docs-gc.js",
    "chrome:pin": "node -e \"const S=require('./source/server/SheetSetPrinter.js');const P=require('path'),O=require('os');const B=S.pinnedChromeBuild();const D=process.env.PUPPETEER_CACHE_DIR||P.join(O.homedir(),'.cache','puppeteer');console.log('installing chrome-headless-shell@'+B+' into '+D);require('child_process').execFileSync('npx',['--yes','@puppeteer/browsers','install','chrome-headless-shell@'+B,'--path',D],{stdio:'inherit'});console.log('resolves to: '+S.resolveChromium());\"",
    "schema:compile": "npx stricture compile data_model/Plansheet.ddl -o data_model/compiled/ -p Plansheet",
    "build-docs": "npx quack build && npx quack copy && npx pict-docuserve inject ./docs && node -e \"const fs=require('fs'),path=require('path'); const src=path.join(__dirname,'dist'),dst=path.join(__dirname,'docs','app'); fs.rmSync(dst,{recursive:true,force:true}); fs.mkdirSync(dst,{recursive:true}); for(const f of fs.readdirSync(src)) fs.copyFileSync(path.join(src,f),path.join(dst,f)); console.log('Copied',fs.readdirSync(dst).length,'files into docs/app/');\"",
    "serve-docs": "npx pict-docuserve serve ./docs -p 8192",
    "test": "npx mocha -u tdd -R spec test/*_tests.js",
    "test:e2e": "node test/e2e/run.js",
    "test:fuzz": "node test/e2e/fuzz.js",
    "test:oauth": "node dev/oauth-e2e.js",
    "test:noderegistration": "node dev/node-registration-e2e.js"
  },
  "retold": {
    "brandConfig": {
      "Palette": "ocean",
      "DisplayName": "Plansheet",
      "Tagline": "Everything, drafted."
    },
    "brand": {
      "Hash": "plansheet",
      "Name": "Plansheet",
      "Tagline": "Everything, drafted.",
      "Palette": "ocean",
      "Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><rect width=\"32\" height=\"32\" rx=\"5\" fill=\"#11386B\"/><rect x=\"4.5\" y=\"4.5\" width=\"23\" height=\"23\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2\"/><line x1=\"4.5\" y1=\"21\" x2=\"27.5\" y2=\"21\" stroke=\"#EAF2FC\" stroke-width=\"1.6\"/><line x1=\"12.5\" y1=\"8.5\" x2=\"12.5\" y2=\"17.5\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><circle cx=\"16\" cy=\"11.6\" r=\"3.8\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><line x1=\"8\" y1=\"24.6\" x2=\"17\" y2=\"24.6\" stroke=\"#F2C84B\" stroke-width=\"2.2\"/></svg>",
      "IconType": "svg",
      "Favicon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><rect width=\"32\" height=\"32\" rx=\"5\" fill=\"#11386B\"/><rect x=\"4.5\" y=\"4.5\" width=\"23\" height=\"23\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2\"/><line x1=\"4.5\" y1=\"21\" x2=\"27.5\" y2=\"21\" stroke=\"#EAF2FC\" stroke-width=\"1.6\"/><line x1=\"12.5\" y1=\"8.5\" x2=\"12.5\" y2=\"17.5\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><circle cx=\"16\" cy=\"11.6\" r=\"3.8\" fill=\"none\" stroke=\"#EAF2FC\" stroke-width=\"2.6\"/><line x1=\"8\" y1=\"24.6\" x2=\"17\" y2=\"24.6\" stroke=\"#F2C84B\" stroke-width=\"2.2\"/></svg>",
      "FaviconDark": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-plansheet-dark\">\n\t\t\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\" fill=\"#4F95E8\"/>\n\t\t<g clip-path=\"url(#fav-plansheet-dark)\"><path d=\"M 16 26 L 48 66 L 80 26 Z\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#101418\" letter-spacing=\"-1\">P</text>\n\t</svg>",
      "Colors": {
        "Primary": "#1D5FA8",
        "Secondary": "#A8780E",
        "PrimaryLight": "#1D5FA8",
        "PrimaryDark": "#4F95E8",
        "SecondaryLight": "#A8780E",
        "SecondaryDark": "#F2C84B"
      }
    },
    "//brand-mark": "Icon/Favicon are the hand-drawn corner-cell-P title-block mark; do NOT run npm run brand, it would regenerate a geometric logo and clobber them. brandConfig.Palette stays for the generator metadata but the app default theme is set in Pict-Application-Plansheet.js (ApplyDefault plansheet)."
  },
  "author": "Steven Velozo <steven@velozo.com>",
  "license": "MIT",
  "dependencies": {
    "@codemirror/lang-markdown": "^6.5.0",
    "@codemirror/state": "^6.7.0",
    "@codemirror/view": "^6.43.4",
    "@phosphor-icons/core": "2.1.1",
    "@tabler/icons": "3.44.0",
    "codemirror": "^6.0.2",
    "fable": "^3.1.79",
    "fable-log-logger-bunyan": "^1.0.5",
    "jszip": "^3.10.1",
    "katex": "^0.17.0",
    "marked": "^4.3.0",
    "meadow": "^2.0.47",
    "meadow-connection-postgresql": "^1.0.8",
    "meadow-endpoints": "^4.1.1",
    "mermaid": "^11.16.0",
    "node-diff3": "3.2.1",
    "openid-client": "^6.0.0",
    "openseadragon": "^6.0.2",
    "orator": "^6.1.2",
    "orator-api-description": "^0.0.1",
    "orator-authentication": "^1.1.2",
    "orator-serviceserver-restify": "^2.0.11",
    "parime": "^1.2.0",
    "pg": "^8.22.0",
    "pict": "^1.0.392",
    "pict-application": "^1.0.33",
    "pict-router": "^1.0.13",
    "pict-section-activitygraph": "^1.0.4",
    "pict-section-checklist": "1.2.0",
    "pict-section-comments": "^1.0.0",
    "pict-section-content": "^1.0.18",
    "pict-section-dochistory": "^1.0.0",
    "pict-section-excalidraw": "1.0.3",
    "pict-section-flow": "^2.0.5",
    "pict-section-inlinedocumentation": "^1.0.12",
    "pict-section-login": "^1.1.0",
    "pict-section-markdowneditor": "^1.0.21",
    "pict-section-modal": "^1.1.4",
    "pict-section-moodboard": "^1.4.1",
    "pict-section-navigation": "^1.4.1",
    "pict-section-openseadragon": "^1.0.22",
    "pict-section-picker": "^1.8.2",
    "pict-section-prompteditor": "1.1.4",
    "pict-section-theme": "^1.1.1",
    "pict-section-workspace": "^1.0.0",
    "pict-view": "^1.0.68",
    "postmark": "^4.0.7",
    "puppeteer-core": "25.2.1",
    "retold-operation-queue": "^0.5.1",
    "retold-sharp": "1.0.0",
    "retold-workflow": "^0.5.0",
    "sharp": "0.34.5",
    "simple-icons": "16.24.1",
    "twilio": "^6.0.2"
  },
  "optionalDependencies": {
    "@img/sharp-darwin-arm64": "0.34.5",
    "@img/sharp-linux-arm64": "0.34.5",
    "@img/sharp-linux-x64": "0.34.5"
  },
  "devDependencies": {
    "chai": "^4.5.0",
    "esbuild": "^0.28.1",
    "http-server": "^14.1.1",
    "jsdom": "^25.0.1",
    "meadow-migrationmanager": "^1.0.5",
    "mocha": "^11.0.1",
    "pict-docuserve": "^1.4.19",
    "quackage": "^1.1.2"
  },
  "copyFilesSettings": {
    "whenFileExists": "overwrite"
  },
  "copyFiles": [
    {
      "from": "./html/*",
      "to": "./dist/"
    },
    {
      "from": "./html/favicons/*",
      "to": "./dist/favicons/"
    },
    {
      "from": "./fonts/*",
      "to": "./dist/fonts/"
    },
    {
      "from": "./node_modules/pict/dist/*",
      "to": "./dist/"
    },
    {
      "from": "./node_modules/katex/dist/katex.min.css",
      "to": "./dist/katex/"
    },
    {
      "from": "./node_modules/katex/dist/katex.min.js",
      "to": "./dist/katex/"
    },
    {
      "from": "./node_modules/katex/dist/fonts/*",
      "to": "./dist/katex/fonts/"
    },
    {
      "from": "./node_modules/mermaid/dist/mermaid.min.js",
      "to": "./dist/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/react-vendor.min.js",
      "to": "./dist/js/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/excalidraw-wrapper.min.js",
      "to": "./dist/js/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/excalidraw-wrapper.css",
      "to": "./dist/css/"
    },
    {
      "from": "./node_modules/pict-section-excalidraw/vendor/excalidraw-built/assets/**/*",
      "to": "./dist/js/excalidraw-assets/"
    },
    {
      "from": "./node_modules/openseadragon/build/openseadragon/openseadragon.min.js",
      "to": "./dist/"
    },
    {
      "from": "./node_modules/openseadragon/build/openseadragon/images/*",
      "to": "./dist/openseadragon-images/"
    }
  ]
}
